<template>
    <div class="row">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-4 col-xl-8 offset-xl-2">
            <div class="content-simple-image">
                <img :src="url()" alt="" title="" />
                <p>{{value.image.title}} — {{value.image.credits}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '@/utils'

export default {
    name: 'Photo',
    props:['value'],
    methods: {
        url(){
            return utils.image(this.value.image, 'orig', 'orig')
        }
    }
}
</script>